export default __webpack_public_path__ + "static/media/AshokaMinionParticleWave.78f5b13c.png";